"use client"

import { from, split } from "@apollo/client"
import { setContext } from "@apollo/client/link/context"
import { ApolloNextAppProvider, SSRMultipartLink, ApolloClient } from "@apollo/experimental-nextjs-app-support"
import createUploadLink from "apollo-upload-client/createUploadLink.mjs"
import { getSession } from "next-auth/react"
import { cache } from "./cache"

const isProd = process.env.NEXT_PUBLIC_NODE_ENV === "production"

const uri = isProd ? "https://novantwrk.fly.dev/graphql/" : "https://novantwrk-dev.fly.dev/graphql/"

export const terminatingLink = split(
  ({ getContext }) => {
    const version = getContext().version
    if (![1, 2].includes(version)) {
      return true
    }
    return version === 1
  },
  createUploadLink({ uri: ({ operationName }) => (isProd ? uri : `${uri}?n=${operationName}`) }),
  createUploadLink({
    uri: ({ operationName }) =>
      isProd
        ? `${uri.replace("/graphql/", "/graphql/v2/")}`
        : `${uri.replace("/graphql/", "/graphql/v2/")}?n=${operationName}`,
  })
)

function makeClient() {
  const authLink = setContext(async (_, { headers }) => {
    const session = await getSession()
    return {
      headers: {
        ...headers,
        Authorization: session ? `JWT ${session.accessToken}` : "",
      },
    }
  })

  const link =
    typeof window === "undefined"
      ? from([
          new SSRMultipartLink({
            stripDefer: true,
          }),
          authLink,
          terminatingLink,
        ])
      : from([authLink, terminatingLink])

  return new ApolloClient({
    cache: cache,
    link: link,
  })
}
export function ExperimentalApolloWrapper({ children }: React.PropsWithChildren) {
  return <ApolloNextAppProvider makeClient={makeClient}>{children}</ApolloNextAppProvider>
}
